"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CORE_ORIGIN = 'https://app.core-value.ch';
const ValueAppWidget = _ref => {
  let {
    apiKey,
    type = 'project_architect',
    lang = 'de-CH',
    meta,
    entry,
    onSaveCallback
  } = _ref;
  const widgetRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (!widgetRef.current) return;
    const element = widgetRef.current;
    const timestamp = Date.now();
    const cssPath = '/ValueAppWidget.css';
    const link = `${CORE_ORIGIN}?key=${apiKey}&lang=${lang}&type=${type}&timestamp=${timestamp}&cssPath=${cssPath}`;
    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', link);
    iframe.setAttribute('allow', 'fullscreen');
    iframe.style.border = 'none';
    iframe.style.width = '100%';
    iframe.style.minHeight = '800px';
    element.appendChild(iframe);
    const handleWidgetMessage = e => {
      if (e.origin === CORE_ORIGIN) {
        switch (e.data?.type) {
          case 'init_success':
            iframe.contentWindow.postMessage({
              type: entry ? 'inject_data' : 'default_data',
              meta: JSON.stringify(meta),
              entry: entry ? JSON.stringify(entry) : undefined
            }, CORE_ORIGIN);
            break;
          case 'init_fail':
            console.error('Core init failed: ', e.data);
            break;
          case 'on_error':
            console.error('Core Error: ', e.data);
            break;
          case 'on_save':
            if (e.data?.type == 'on_save' && e.data.data) {
              if (onSaveCallback && typeof window[onSaveCallback] === 'function') {
                window[onSaveCallback](e.data.data);
              }
              onSaveCallback(JSON.parse(e.data.data));
            }
            break;
          default:
            break;
        }
      }
    };
    window.addEventListener('message', handleWidgetMessage);
    return () => {
      window.removeEventListener('message', handleWidgetMessage);
      element.innerHTML = '';
    };
  }, [apiKey, type, lang, entry]);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: widgetRef
  });
};
var _default = exports.default = ValueAppWidget;